// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentFailureModal_container__2rhOB","text":"PaymentFailureModal_text__2WCBT","textBottom":"PaymentFailureModal_textBottom__1zcF- PaymentFailureModal_text__2WCBT"};